import React, { Component } from "react";
import { connect } from "react-redux";
import AdminProfile from "../components/Profile";
import { viewById } from "../../adminActions";
import { close_snack_bar } from "../../../../store/actions/snackbarActions";
export class Controller extends Component {
  render() {
    return <AdminProfile {...this.props} />;
  }
}
export const mapStateToProps = (store) => {
  return {
    login: store.login,
    loader: store.loader,
    snackbar: store.snackbar,
    client: store.client,
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    viewById: (token, admin_id) => {
      dispatch(viewById(token, admin_id));
    },

    close_snack_bar: () => {
      dispatch(close_snack_bar());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Controller);
